import {defineMessages} from 'react-intl';

export const hotspotMapMessages = defineMessages({
  hotspotsRemaining: { id: 'hotspot_map.hotspots_remaining' },
  hotspotsCompleted: { id: 'hotspot_map.hotspots_completed' },
  dragToMove: { id: 'hotspot_map.drag_to_move' },
  nextScrene: { id: 'hotspot_map.next_scene' },
  counterRemaining: { id: 'hotspot_map.counter_remaining' },
  counterReveal: { id: 'hotspot_map.counter_reveal' },
});
